module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-02@2x.3baf51ce.jpg";